import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LoaderIcon, ZapIcon } from 'lucide-react';
import type { TaskRun } from '../../types/lexce';
interface TaskRunCardProps {
  task: TaskRun;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function TaskRunCard({
  task
}: TaskRunCardProps) {
  const [completed, setCompleted] = useState(0);
  const finished = completed >= task.steps.length;
  useEffect(() => {
    if (finished) return;
    const id = window.setTimeout(() => setCompleted(c => c + 1), 620);
    return () => window.clearTimeout(id);
  }, [completed, finished]);
  return <div className="rounded-2xl border border-vin-line bg-white p-4" data-id="element-155" data-mp="dtnso3c3okd3">
      <div className="flex items-center gap-2" data-id="element-156" data-mp="91nmvu9cmx8l">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-vin-primary text-white" data-id="element-157" data-mp="90umdb0zh3yw">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-158" data-mp="3hfw8gidgenr9" />
        </span>
        <p className="flex-1 text-sm font-semibold text-vin-ink" data-id="element-159" data-mp="3cicuzkokyf0d">{task.title}</p>
        <span className={`text-[11px] font-semibold uppercase tracking-wide ${finished ? 'text-emerald-600' : 'text-vin-muted'}`} data-id="element-160" data-mp="2dxuhzkcmwoap">
          {finished ? 'Done' : 'Working'}
        </span>
      </div>

      <ol className="mt-3 space-y-2.5" data-id="element-161" data-mp="2nqs21ux9ylbf">
        {task.steps.map((step, index) => {
        const state = index < completed ? 'done' : index === completed ? 'active' : 'waiting';
        return <li key={step} className="flex items-start gap-2.5" data-id="element-162" data-mp="1v2cqjidcql4u" data-mpi={index}>
              <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center" data-id="element-163" data-mp="1zzw74oxiv9zy">
                {state === 'done' && <motion.span initial={{
              scale: 0.6,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              duration: 0.18,
              ease: EASE
            }} className="flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500" data-id="element-164" data-mp="250k55uk64r3o">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" strokeWidth={3.5} data-id="element-165" data-mp="1l9oktahszkm2" />
                  </motion.span>}
                {state === 'active' && <LoaderIcon className="h-4 w-4 animate-spin text-vin-tertiary" aria-hidden="true" data-id="element-166" data-mp="1uami79xqktvo" />}
                {state === 'waiting' && <span className="h-1.5 w-1.5 rounded-full bg-vin-line" data-id="element-167" data-mp="1pcb60sjyy7aa" />}
              </span>
              <span className={`text-[13px] leading-5 ${state === 'waiting' ? 'text-vin-line' : 'text-vin-muted'} ${state === 'active' ? 'font-medium text-vin-ink' : ''}`} data-id="element-168" data-mp="11n0dtzgopl7r">
                {step}
              </span>
            </li>;
      })}
      </ol>
    </div>;
}